(function (app, ng) {

    function colorCodeEventTypes(_) {
        this.addCodeToEvent = function (eventTypes) {
            return _.map(eventTypes,
                function (event) {
                    var e = event;
                    var hash = 0;
                    for (var i = 0, len = e.Id.length; i < len; i++) {
                        var char = e.Id.charCodeAt(i);
                        hash = (hash << 5) - hash + char;
                        hash |= 0;
                    }
                    var color = {};
                    color.a = Math.abs((hash & 0xff000000) >> 24);
                    color.r = (hash & 0x00ff0000) >> 16;
                    color.g = (hash & 0x0000ff00) >> 8;
                    color.b = hash & 0x000000ff;
                    var opacity = 0.4; // + ((color.a / 255) / 10);
                    e.textcolor = "#1e1e1e";
                    e.colorstyle = "rgba(" + color.r + "," + color.g + "," + color.b + "," + opacity + ")";
                    return e;
                });
        };
    }

    colorCodeEventTypes.$inject = ["_"];
    app.service('colorCodeEventTypes', colorCodeEventTypes);

})(window.app, window.angular); //jshint ignore:line